<template>
  <div
    :class="[
      `${page}__card`,
      'card',
    ]"
  >
    <slot>Page Content</slot>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    page: {
      type: String,
      default: 'default',
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  @include border-radius($border-radius);

  display: inline-block;
  width: 100%;
  margin-bottom: $gutter;
  padding: calc(#{$gutter} * 1.5);
  overflow: hidden;
  color: white;
  background-color: $dark-blue;
  border: none;

  @media (max-width: $md-max) {
    margin-bottom: calc(#{$gutter} / 3);
  }
}
</style>
